import { DropDownFilter } from 'framework/list';
import OfficeDropdown from '../input/OfficeDropdown';

const OfficeFilterById = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <OfficeDropdown />
    </DropDownFilter>
  );
};

export default OfficeFilterById;
